// Enums to match Java Gender and UserTitle
export enum Gender {
  Male = 'Male',
  Female = 'Female',
}
